import { create } from "zustand";

interface IToggleStore {
  isSidebarVisible: boolean;
  toggleSidebarVisibility: () => void;
  isPersonalAccountOpen: boolean;
  openPersonalAccountOpen: () => void;
  closePersonalAccountOpen: () => void;
}

export const useToggleStore = create<IToggleStore>((set, get) => ({
  isSidebarVisible: false,
  isPersonalAccountOpen: false,
  toggleSidebarVisibility: () => set(() => ({ isSidebarVisible: !get().isSidebarVisible })),
  openPersonalAccountOpen: () => set({ isPersonalAccountOpen: true }),
  closePersonalAccountOpen: () => set({ isPersonalAccountOpen: false }),
}));
